import { PermissionArea } from '../auth/permission.service';

export type ActionCategory = 'navigation' | 'action';

/** Which session context an action needs before it may appear. */
export type ActionContextRequirement = 'none' | 'customer' | 'ua' | 'ps';

/** A curated-core quicklink/action surfaced by the unified search + launchpad. */
export interface AmieAction {
  id: string;
  title: string;
  subtitle?: string;
  icon: string;                 // lucide name (registered in ALL_ICONS)
  category: ActionCategory;
  keywords?: string[];          // extra match terms for search ranking (Plan 3)
  requires: ActionContextRequirement;
  permission?: PermissionArea;  // gated when set
  run: () => void;
}

/** Snapshot of the gating context (derived from session + permission signals). */
export interface ActionAvailabilityContext {
  hasCustomer: boolean;
  hasUserAccount: boolean;
  hasPhoneService: boolean;
  can: (permission: PermissionArea) => boolean;
}

/** True when the action's context requirement and permission (if any) are both satisfied. */
export function isActionAvailable(action: AmieAction, ctx: ActionAvailabilityContext): boolean {
  switch (action.requires) {
    case 'customer': if (!ctx.hasCustomer) return false; break;
    // ua/ps handlers build `/${customerId}/ua|ps/…`, so they also need a customer in context —
    // otherwise a selected UA/PS without a customer would route to `/null/ua/…`.
    case 'ua': if (!ctx.hasCustomer || !ctx.hasUserAccount) return false; break;
    case 'ps': if (!ctx.hasCustomer || !ctx.hasPhoneService) return false; break;
    case 'none': break;
  }
  if (action.permission && !ctx.can(action.permission)) return false;
  return true;
}
